/* Neyli : retour contextuel vers la collection d'origine.
   - Sur une page collection : mémorise l'adresse exacte (filtres, tri, page) et la position de défilement
     au moment où le visiteur ouvre une fiche produit.
   - Sur une fiche produit : affiche « ← Retour à <collection> » vers cette adresse, sinon « Tous mes tapis ».
   - Au retour, la position de défilement est restaurée. */
(function () {
  if (window.__neilyBack) return;
  window.__neilyBack = true;

  var KEY = 'neilyBackOrigin';
  var RESTORE = 'neilyBackRestore';
  var ALL_LABEL = 'Tous mes tapis';
  var LABELS = { 'tapis-eveil': ALL_LABEL, all: ALL_LABEL };

  function store() {
    try {
      return window.sessionStorage;
    } catch (e) {
      return null;
    }
  }
  function read(k) {
    var s = store();
    if (!s) return null;
    try {
      return JSON.parse(s.getItem(k) || 'null');
    } catch (e) {
      return null;
    }
  }
  function write(k, v) {
    var s = store();
    if (!s) return;
    try {
      if (v === null) s.removeItem(k);
      else s.setItem(k, JSON.stringify(v));
    } catch (e) {}
  }

  var ctxEl = document.getElementById('neily-back-context');
  var ctx = {};
  try {
    ctx = JSON.parse((ctxEl && ctxEl.textContent) || '{}');
  } catch (e) {}

  function productHandleFromLink(a) {
    if (!a || !a.href) return null;
    var u;
    try {
      u = new URL(a.href, location.href);
    } catch (e) {
      return null;
    }
    if (u.origin !== location.origin) return null;
    var m = u.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function cleanUrl(href) {
    // On retire le paramètre d'aperçu de thème et la variante éventuelle
    try {
      var u = new URL(href, location.href);
      u.searchParams.delete('preview_theme_id');
      u.hash = '';
      return u.pathname + u.search;
    } catch (e) {
      return href;
    }
  }

  // ---------- Pages collection ----------
  if (ctx.template === 'collection' && ctx.handle) {
    var label = LABELS[ctx.handle] || ctx.title || ALL_LABEL;

    document.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest && e.target.closest('a[href*="/products/"]');
        var handle = productHandleFromLink(a);
        if (!handle) return;
        write(KEY, {
          product: handle,
          url: cleanUrl(location.href),
          label: label,
          scroll: Math.round(window.scrollY),
          ts: Date.now(),
        });
      },
      true
    );

    // Restauration du défilement après un clic sur « Retour à … »
    var restore = read(RESTORE);
    if (restore && restore.url === cleanUrl(location.href)) {
      write(RESTORE, null);
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var y = restore.scroll || 0;
      var tries = 0;
      var tick = function () {
        window.scrollTo(0, y);
        tries++;
        if (Math.abs(window.scrollY - y) > 2 && tries < 20) setTimeout(tick, 100);
      };
      if (document.readyState === 'complete') tick();
      else window.addEventListener('load', tick);
    }
    return;
  }

  // ---------- Fiches produit ----------
  if (ctx.template !== 'product' || !ctx.product) return;
  var nav = document.querySelector('[data-neily-back]');
  var link = nav && nav.querySelector('.neily-back__link');
  if (!link) return;
  var text = link.querySelector('.neily-back__text');

  var origin = read(KEY);
  var sameSiteReferrer = false;
  try {
    sameSiteReferrer = !!document.referrer && new URL(document.referrer).origin === location.origin;
  } catch (e) {}

  var valid = origin && origin.product === ctx.product && origin.url && sameSiteReferrer;

  if (valid) {
    link.href = origin.url;
    text.textContent = 'Retour à ' + origin.label;
  }
  // Sinon : le lien rendu par le thème (collection de l'adresse ou « Tous mes tapis ») reste en place.

  link.addEventListener('click', function (e) {
    if (!valid) return;
    // Si la page précédente est exactement la liste d'origine, on y revient par l'historique :
    // le navigateur restitue alors l'état complet (filtres, tri, défilement).
    var ref = '';
    try {
      ref = cleanUrl(document.referrer);
    } catch (err) {}
    if (ref === origin.url && history.length > 1) {
      e.preventDefault();
      history.back();
      return;
    }
    write(RESTORE, { url: origin.url, scroll: origin.scroll || 0 });
  });

  // Produit ouvert depuis une fiche produit (produits recommandés) : on conserve la collection d'origine
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      var handle = productHandleFromLink(a);
      if (!handle || handle === ctx.product) return;
      var base = valid ? origin : { url: link.getAttribute('href'), label: text.textContent.replace(/^Retour à\s*/, ''), scroll: 0 };
      write(KEY, { product: handle, url: base.url, label: base.label, scroll: base.scroll || 0, ts: Date.now() });
    },
    true
  );
})();
